// src/pages/Accounting/Reports/AccountList/components/LoadingState.tsx

import React from 'react';

export default function LoadingState() {
  return (
    <div className="py-12 flex flex-col items-center gap-2.5">
      <div className="w-1/2 h-3 bg-lineSoft rounded animate-pulse" />
      <div className="w-2/3 h-3 bg-lineSoft rounded animate-pulse" />
      <div className="w-full h-3 bg-lineSoft rounded animate-pulse" />
      <div className="w-full h-3 bg-lineSoft rounded animate-pulse" />
      <div className="w-3/4 h-3 bg-lineSoft rounded animate-pulse" />
      <div className="w-full h-3 bg-lineSoft rounded animate-pulse" />
    </div>
  );
}